import { graphql } from "@/graphql/generated/gql";

// ============== QUERIES ======================
export const workspaceByUrlQueryDocument = graphql(/* GraphQL */ `
  query workspaceByUrl($input: String!) {
    workspaceByUrl(workspaceUrl: $input) {
      id
      name
      workspaceUrl
      logo
      municipalityList {
        ...MunicipalityListFields
      }
      targetYear
      customDomain
      defaultPublicDashboardId
      updatedAt
      createdAt
      workspaceMembershipList {
        ...WorkspaceMembershipFields
      }
      storedViewList {
        ...StoredViewFields
      }
      twoFactorAuth {
        id
        workspaceId
        isRequired
        createdAt
        updatedAt
      }
    }
  }
`);

export const workspaceByIdQueryDocument = graphql(/* GraphQL */ `
  query workspaceById($input: String!) {
    workspaceById(workspaceId: $input) {
      id
      name
      workspaceUrl
      logo
      municipalityList {
        ...MunicipalityListFields
      }
      targetYear
      customDomain
      defaultPublicDashboardId
      userLimit
      coreUserLimit
      guestUserLimit
      consumedSeatCount
      consumedCoreSeatCount
      consumedGuestSeatCount
      updatedAt
      createdAt
      workspaceMembershipList {
        ...WorkspaceMembershipFields
      }
      storedViewList {
        ...StoredViewFields
      }
      twoFactorAuth {
        id
        workspaceId
        isRequired
        createdAt
        updatedAt
      }
    }
  }
`);

// ============== MUTATIONS ======================
export const updateWorkspaceMutationDocument = graphql(/* GraphQL */ `
  mutation updateWorkspace($input: WorkspaceUpdateInput!) {
    updateWorkspace(workspaceUpdateInput: $input) {
      id
      name
      workspaceUrl
      logo
      municipalityList {
        ...MunicipalityListFields
      }
      targetYear
      updatedAt
      createdAt
      phaseList {
        ...PhaseFields
        instanceList {
          id
        }
      }
      priorityList {
        ...PriorityFields
        instanceList {
          id
        }
      }
      unitList {
        ...UnitFields
      }
      focusAreaList {
        ...FocusAreaFields
        instanceList {
          id
        }
      }
      labelList {
        ...LabelFields
        instanceList {
          id
        }
      }
      labelGroupList {
        ...LabelGroupFields
      }
      workspaceMembershipList {
        ...WorkspaceMembershipFields
      }

      storedViewList {
        ...StoredViewFields
      }
      twoFactorAuth {
        id
        workspaceId
        isRequired
        createdAt
        updatedAt
      }
    }
  }
`);

export const deleteWorkspaceMutationDocument = graphql(/* GraphQL */ `
  mutation deleteWorkspace($input: WorkspaceDeleteInput!) {
    deleteWorkspace(workspaceDeleteInput: $input) {
      id
      name
      workspaceUrl
      logo
      createdAt
      updatedAt
    }
  }
`);

export const sendWorkspaceDeleteCodeEmailMutationDocument = graphql(/* GraphQL */ `
  mutation sendWorkspaceDeleteCodeEmail($input: WorkspaceDeleteCodeCreateInput!) {
    sendWorkspaceDeleteCodeEmail(workspaceDeleteCodeCreateInput: $input) {
      success
      email
      message
    }
  }
`);
